var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedPacketOver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "440px",
    height: "263px",
    viewBox: "0 0 440 263",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5F62\u72B6\u7ED3\u5408") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "32.1365171%",
    x2: "0%",
    y2: "67.8634829%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3B44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474566",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0627\\u66F4\\u65B0--\\u7EA2\\u5305airdrop-\\u9886\\u7EA2\\u5305-\\u5DF2\\u9886\\u5B8C",
    transform: "translate(-500.000000, -200.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27",
    transform: "translate(499.996798, 200.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.003202,0 C432.839758,-3.30170024e-14 440.003202,7.163444 440.003202,16 L440.00507,222.642207 C378.765349,247.970327 302.409138,263 219.614313,263 C137.169036,263 61.1081228,248.096966 -6.39488462e-14,222.962451 L0.00320219216,16 C0.00320219216,7.163444 7.16664619,1.623249e-15 16.0032022,0 L424.003202,0 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedPacketOver);
export default __webpack_public_path__ + "static/media/redPacketOver.62d5655b5c1712b3d2792929ce388503.svg";
export { ForwardRef as ReactComponent };